import React from "react";
import styled from "styled-components";

export const HorizontalLine = styled((props) => <hr {...props} />).attrs(
  (props) => ({
    automationid:
      props.automationid ||
      `SalesLead_hr_${props?.automationidattr?.replace(/ /g, "")}_1"`,
  })
)`
  margin: auto;
  margin-bottom: ${(props) => props.spacing || "1.5rem"};
  margin-top: ${(props) => props.spacing || "1.5rem"};
  border: none;
  border-bottom: 1px solid #ddd;
`;
